import React from 'react';

class CreateChannel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: !props.width ? 50 : props.width,
      height: !props.height ? 50 : props.height,
      color: !props.color ? '#ddd' : props.color,
    };
  }

  render() {
    return (
      <svg
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        width={this.state.width}
        height={this.state.height}
        viewBox={`0 0 ${this.state.width} ${this.state.height}`}>
        <g id="group_1421" data-name="group 1421" transform="translate(-476 -1074)">
          <g
            id="circle_16"
            data-name="circle 16"
            transform="translate(476 1074)"
            fill="rgba(255,255,255,0)"
            stroke={this.state.color}
            strokeWidth="4">
            <circle cx="25" cy="25" r="25" stroke="none" />
            <circle cx="25" cy="25" r="23" fill="none" />
          </g>
          <path
            id="plus-solid"
            d="M18.571,39.857H12.143V33.429A1.429,1.429,0,0,0,10.714,32H9.286a1.429,1.429,0,0,0-1.429,1.429v6.429H1.429A1.429,1.429,0,0,0,0,41.286v1.429a1.429,1.429,0,0,0,1.429,1.429H7.857v6.429A1.429,1.429,0,0,0,9.286,52h1.429a1.429,1.429,0,0,0,1.429-1.429V44.143h6.429A1.429,1.429,0,0,0,20,42.714V41.286A1.429,1.429,0,0,0,18.571,39.857Z"
            transform="translate(491 1057)"
            fill={this.state.color}
          />
        </g>
      </svg>
    );
  }
}

export default CreateChannel;
